import React, { useEffect, useState } from 'react';
import './dash.css';
import { FaBook, FaShoppingCart, FaUsers } from 'react-icons/fa';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip
} from 'chart.js';

import API_BASE from '../api/api';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Legend, Tooltip);

const Dashboard = () => {

  const [stats, setStats] = useState({
    total_books: 0,
    total_orders: 0,
    total_users: 0
  });

  const [graphData, setGraphData] = useState({
    labels: [],
    books: [],
    orders: []
  });

  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH STATS ---------------- */
/* ---------------- FETCH STATS ---------------- */
useEffect(() => {
  fetch(`${API_BASE}/status.php`, {
    credentials: "include"
  })
    .then(res => res.json())
    .then(data => {

      if (data.status === "success") {
        setStats(data.data); // ✅ FIXED
      } else {
        console.error(data.message);
        alert(data.message);
      }

    })
    .catch(err => {
      console.error(err);
      alert("Failed to load dashboard stats");
    });
}, []);

/* ---------------- FETCH GRAPH ---------------- */
useEffect(() => {
  fetch(`${API_BASE}/activity.php`, {
    credentials: "include"
  })
    .then(res => res.json())
    .then(data => {

      if (data.status === "success" && Array.isArray(data.data)) {

        setGraphData({
          labels: data.data.map(i => i.date),
          books: data.data.map(i => i.books),
          orders: data.data.map(i => i.orders)
        });

      } else {
        console.error("Graph error:", data);
      }

      setLoading(false); // 🔥 ADD THIS

    })
    .catch(err => {
      console.error(err);
      alert("Failed to load activity graph");
      setLoading(false); // 🔥 ADD THIS
    });
}, []);

  const chartData = {
    labels: graphData.labels,
    datasets: [
      {
        label: 'Books Added',
        data: graphData.books,
        borderColor: '#2d87c8',
        backgroundColor: '#2d87c8',
        tension: 0.3,
      },
      {
        label: 'Orders Placed',
        data: graphData.orders,
        borderColor: '#28a745',
        backgroundColor: '#28a745',
        tension: 0.3,
      },
    ],
  };

  if (loading) {
    return <div className="dashboard">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">

      <h1 className="dashboard-title">Sangit Shree Prakashan</h1>

      <div className="dashboard-cards">

        <div className="dashboard-card blue">
          <FaBook className="card-icon" />
          <div>
            <h3>Total Books</h3>
            <p>{stats.total_books}</p>
          </div>
        </div>

        <div className="dashboard-card green">
          <FaShoppingCart className="card-icon" />
          <div>
            <h3>Total Orders</h3>
            <p>{stats.total_orders}</p>
          </div>
        </div>

        <div className="dashboard-card purple">
          <FaUsers className="card-icon" />
          <div>
            <h3>Total Users</h3>
            <p>{stats.total_users}</p>
          </div>
        </div>

      </div>

      <div className="dashboard-graph">
        <h2 className="graph-title">Weekly Activity</h2>
        <Line data={chartData} />
      </div>

    </div>
  );
};

export default Dashboard;